import AdminContentWrapper from './AdminContentWrapper';

export default AdminContentWrapper;
